import { UserWtrIcon } from "../icons";
import Create from "./Create";
import List from "./List";

export default {
	icon: UserWtrIcon,
	list: List,
	create: Create,
	options: {
		group: "dashboard",
		roles: ["admin", "user"],
	},
};
